export const gridPlusIconSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="grid-plus-1" fill="white">
        <rect x="4" y="4" width="7.11111" height="7.11111" rx="0.888889" />
    </mask>
    <rect x="4" y="4" width="7.11111" height="7.11111" rx="0.888889" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" mask="url(#grid-plus-1)"/>
    <mask id="grid-plus-2" fill="white">
        <rect x="12.8889" y="4" width="7.11111" height="7.11111" rx="0.888889" />
    </mask>
    <rect x="12.8889" y="4" width="7.11111" height="7.11111" rx="0.888889" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" mask="url(#grid-plus-2)"/>
    <mask id="grid-plus-3" fill="white">
        <rect x="4" y="12.8889" width="7.11111" height="7.11111" rx="0.888889" />
    </mask>
    <rect x="4" y="12.8889" width="7.11111" height="7.11111" rx="0.888889" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" mask="url(#grid-plus-3)"/>
    <path d="M13.5 16.5L19.5 16.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M16.5 13.5L16.5 19.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>`

const GridPlusIcon = ({ size = 24, color = 'currentColor', ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <mask id="grid-plus-1" fill="white">
                <rect x="4" y="4" width="7.11111" height="7.11111" rx="0.888889" />
            </mask>
            <rect
                x="4"
                y="4"
                width="7.11111"
                height="7.11111"
                rx="0.888889"
                stroke={color}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                mask="url(#grid-plus-1)"
            />
            <mask id="grid-plus-2" fill="white">
                <rect x="12.8889" y="4" width="7.11111" height="7.11111" rx="0.888889" />
            </mask>
            <rect
                x="12.8889"
                y="4"
                width="7.11111"
                height="7.11111"
                rx="0.888889"
                stroke={color}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                mask="url(#grid-plus-2)"
            />
            <mask id="grid-plus-3" fill="white">
                <rect x="4" y="12.8889" width="7.11111" height="7.11111" rx="0.888889" />
            </mask>
            <rect
                x="4"
                y="12.8889"
                width="7.11111"
                height="7.11111"
                rx="0.888889"
                stroke={color}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                mask="url(#grid-plus-3)"
            />
            <path d="M13.5 16.5L19.5 16.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
            <path d="M16.5 13.5L16.5 19.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    )
}

export default GridPlusIcon
